import {Injectable} from '@angular/core';
import {IRecourceMap} from "@ispm/navigation/interfaces";

@Injectable({
  providedIn: 'root'
})
export class NavigationHelperService {
  private isNavTriggerInPopState: boolean;
  private resourceMap: IRecourceMap;

  constructor() {
  }

  setNavigationTriggerState(navigationTriggerPopState: boolean): void {
    this.isNavTriggerInPopState = navigationTriggerPopState;
  }

  getNavigationTriggerState(): boolean {
    return this.isNavTriggerInPopState;
  }

  setNavigationParams(resourceMapObj:IRecourceMap): void {
    this.resourceMap = resourceMapObj;
  }
  resetNavigationParams(): void {
    this.resourceMap = null;
  }
   getNavigationParams(): IRecourceMap {
    return this.resourceMap;
  }

}
